import CharityModal from './CharityModal';

export default CharityModal;
